import type {
  ICart,
  ICartEntryDetailsOffer,
  ICartEntryDetailsReward,
  ICartEntryReward,
  ICreateCartEntryParams,
  ILegacyCartEntry,
  ILegacyCartEntryDetailsReward,
} from './incentive-cart';
import { ICartEntryType } from './incentive-cart';

export * from './incentive-cart/types';

export type IInRestaurantIncentive =
  | ICartEntryDetailsReward['reward']
  | ILegacyCartEntryDetailsReward['engineReward']
  | ICartEntryDetailsOffer['offer'];

export type IAddInRestaurantCartEntryResult = {
  entry: ILegacyCartEntry | null;
  evictedRewardEntries: ICartEntryReward[];
  decrementedRewardEntries: ICartEntryReward[];
};

export interface IUseInRestaurantCart {
  inRestaurantCart: ICart;
  isInRestaurantCartEmpty: boolean;
  addInRestaurantCartEntry: (item: ICreateCartEntryParams) => IAddInRestaurantCartEntryResult;
  removeInRestaurantCartEntry: (cartEntry: ILegacyCartEntry) => void;
  updateInRestaurantCartEntryQuantity(cartEntry: ILegacyCartEntry, quantity: number): void;
  resetInRestaurantCart: () => void;
  clearInRestaurantCartAllRewards: () => void;
  existEntryTypeInRestaurantCart: (entryType: ICartEntryType) => boolean;
  removeTypeFromCart: (typeToRemove: ICartEntryType) => void;
}
